import { css } from "styled-components";
export const riotProductSkin = (chroma) => css `
  --max-blade-content: 1920px;
  --blade-content-increment: 320px;

  margin: 0 auto;
  padding-left: ${chroma.spacers.variable.l};
  padding-right: ${chroma.spacers.variable.l};
  width: 100%;

  &.width-small {
    max-width: calc(var(--max-blade-content) - (3 * var(--blade-content-increment)));
  }

  &.width-medium {
    max-width: calc(var(--max-blade-content) - (2 * var(--blade-content-increment)));
  }

  &.width-large {
    max-width: calc(var(--max-blade-content) - var(--blade-content-increment));
  }

  &.width-xlarge {
    max-width: var(--max-blade-content);
  }
`;
//# sourceMappingURL=index.js.map